<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'申请入驻孵化器审核',goback:true},{name:'孵化器详情'}]" :title="'孵化器详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
					    <div class="name">孵化器名称：</div>
					    <div class="content">{{dataInfo.incubatorName||'--'}}</div>
					</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">场地租金：</div>
                        <div class="content">{{dataInfo.rent||'--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">孵化器总面积：</div>
                      <div class="content">{{dataInfo.area||'--'}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">所在地区：</div>
                        <div class="content">{{dataInfo.provinceValue+dataInfo.cityValue+dataInfo.areaValue}}</div>
                    </div>
                  </el-col>
                  </el-row>
                  <el-row>
                    
                  <el-col :span="24">
                    <div class="child">
                      <div class="name">详细地址：</div>
                      <div class="content">
                          {{dataInfo.address}}
                          <baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true" @ready="handler" ak="GYITHUGEzlm5UAajtqbakGqqmHwGVdrK">
                              <bm-marker :position="maker" :dragging="true"></bm-marker>
                          </baidu-map>
                      </div>
                  </div>
                  </el-col>
                 </el-row>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">联系手机号：</div>
                          <div class="content">{{dataInfo.contactPhone||'--'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">建成时间：</div>
                          <div class="content">{{dataInfo.createTime||'--'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">简介：</div>
                          <div class="content">
                          {{dataInfo.remark||'--'}}
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="child">
                      <div class="name">孵化器照片：</div>
                      <div class="content" v-show="dataInfo">
                          <div class="content-img" v-for="(img,index) in dataInfo.fileList" :key="index">
                        <div v-if="img.isCover==1">封面</div>
                        <img style="width: 100%;height: 100%;" :src="dataInfo.frontPath+img.filePath" class="images">
                      </div>
                        
                      </div>
                  </div>
                  </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">招商产业：</div>
                        <div class="content">
                          {{dataInfo.industry||'--'}}
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">配套设施：</div>
                        <div class="content">
                          {{dataInfo.facilities||'--'}}
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">地理环境：</div>
                        <div class="content">
                          {{dataInfo.environment||'--'}}
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
					    <div class="name">交通路线：</div>
						<div class="content">
							{{dataInfo.trafficRoutes||'--'}}
						</div>
					</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">其它服务：</div>
                        <div class="content">
                          {{dataInfo.otherServices||'--'}}
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
					    <div class="name">入驻须知：</div>
						<div class="content">
							{{dataInfo.industry||'--'}}
						</div>
					</div>
                    </el-col>
                    
                  </el-row>
                 
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            dataInfo:{
                id:void 0,
                fileList:[]
            },
            center:{},//地图中心点
            maker:{},//标记点
            zoom:15,//缩放等级
		
        }
    },
    methods:{
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/incubator/details/'+this.id)
          if (code == 200) {            
              this.dataInfo=data;
              this.maker={lng: data.longitude, lat: data.latitude};
					    this.center={lng:data.longitude, lat: data.latitude};
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>